/* tslint:disable */
/* eslint-disable */
/**
 * Amplified Intelligence - Media Plans API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../../runtime';
import type { AdjustmentToleranceLevel } from './AdjustmentToleranceLevel';
import {
    AdjustmentToleranceLevelFromJSON,
    AdjustmentToleranceLevelFromJSONTyped,
    AdjustmentToleranceLevelToJSON,
} from './AdjustmentToleranceLevel';
import type { AgeGroup } from './AgeGroup';
import { AgeGroupFromJSON, AgeGroupFromJSONTyped, AgeGroupToJSON } from './AgeGroup';
import type { BudgetConstraintType } from './BudgetConstraintType';
import {
    BudgetConstraintTypeFromJSON,
    BudgetConstraintTypeFromJSONTyped,
    BudgetConstraintTypeToJSON,
} from './BudgetConstraintType';
import type { CountryCodeIso2 } from './CountryCodeIso2';
import {
    CountryCodeIso2FromJSON,
    CountryCodeIso2FromJSONTyped,
    CountryCodeIso2ToJSON,
} from './CountryCodeIso2';
import type { Gender } from './Gender';
import { GenderFromJSON, GenderFromJSONTyped, GenderToJSON } from './Gender';
import type { OptimisationStrategy } from './OptimisationStrategy';
import {
    OptimisationStrategyFromJSON,
    OptimisationStrategyFromJSONTyped,
    OptimisationStrategyToJSON,
} from './OptimisationStrategy';
import type { ScenarioAdFormatResponseDto } from './ScenarioAdFormatResponseDto';
import {
    ScenarioAdFormatResponseDtoFromJSON,
    ScenarioAdFormatResponseDtoFromJSONTyped,
    ScenarioAdFormatResponseDtoToJSON,
} from './ScenarioAdFormatResponseDto';
import type { ScenarioMinSpendPerChannelResponseDto } from './ScenarioMinSpendPerChannelResponseDto';
import {
    ScenarioMinSpendPerChannelResponseDtoFromJSON,
    ScenarioMinSpendPerChannelResponseDtoFromJSONTyped,
    ScenarioMinSpendPerChannelResponseDtoToJSON,
} from './ScenarioMinSpendPerChannelResponseDto';
import type { ScenarioStatus } from './ScenarioStatus';
import {
    ScenarioStatusFromJSON,
    ScenarioStatusFromJSONTyped,
    ScenarioStatusToJSON,
} from './ScenarioStatus';

/**
 *
 * @export
 * @interface BaseScenarioResponseDto
 */
export interface BaseScenarioResponseDto {
    /**
     *
     * @type {string}
     * @memberof BaseScenarioResponseDto
     */
    campaignId?: string;
    /**
     *
     * @type {OptimisationStrategy}
     * @memberof BaseScenarioResponseDto
     */
    optimisationStrategy?: OptimisationStrategy;
    /**
     *
     * @type {string}
     * @memberof BaseScenarioResponseDto
     */
    scenarioName?: string | null;
    /**
     *
     * @type {ScenarioStatus}
     * @memberof BaseScenarioResponseDto
     */
    scenarioStatus?: ScenarioStatus;
    /**
     *
     * @type {Array<CountryCodeIso2>}
     * @memberof BaseScenarioResponseDto
     */
    countries?: Array<CountryCodeIso2> | null;
    /**
     *
     * @type {Array<Gender>}
     * @memberof BaseScenarioResponseDto
     */
    genders?: Array<Gender> | null;
    /**
     *
     * @type {Array<AgeGroup>}
     * @memberof BaseScenarioResponseDto
     */
    ageGroups?: Array<AgeGroup> | null;
    /**
     *
     * @type {Date}
     * @memberof BaseScenarioResponseDto
     */
    startDate?: Date | null;
    /**
     *
     * @type {Date}
     * @memberof BaseScenarioResponseDto
     */
    endDate?: Date | null;
    /**
     *
     * @type {BudgetConstraintType}
     * @memberof BaseScenarioResponseDto
     */
    budgetConstraintType?: BudgetConstraintType;
    /**
     *
     * @type {AdjustmentToleranceLevel}
     * @memberof BaseScenarioResponseDto
     */
    adjustmentToleranceLevel?: AdjustmentToleranceLevel;
    /**
     *
     * @type {Array<ScenarioAdFormatResponseDto>}
     * @memberof BaseScenarioResponseDto
     */
    adFormats?: Array<ScenarioAdFormatResponseDto> | null;
    /**
     *
     * @type {Array<ScenarioMinSpendPerChannelResponseDto>}
     * @memberof BaseScenarioResponseDto
     */
    minSpendPerChannels?: Array<ScenarioMinSpendPerChannelResponseDto> | null;
    /**
     *
     * @type {boolean}
     * @memberof BaseScenarioResponseDto
     */
    isUsingGlobalCountry?: boolean | null;
    /**
     *
     * @type {boolean}
     * @memberof BaseScenarioResponseDto
     */
    isAccessibleToEveryone?: boolean | null;
    /**
     *
     * @type {string}
     * @memberof BaseScenarioResponseDto
     */
    id?: string;
    /**
     *
     * @type {Date}
     * @memberof BaseScenarioResponseDto
     */
    createdAt?: Date;
    /**
     *
     * @type {Date}
     * @memberof BaseScenarioResponseDto
     */
    updatedAt?: Date;
}

/**
 * Check if a given object implements the BaseScenarioResponseDto interface.
 */
export function instanceOfBaseScenarioResponseDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function BaseScenarioResponseDtoFromJSON(json: any): BaseScenarioResponseDto {
    return BaseScenarioResponseDtoFromJSONTyped(json, false);
}

export function BaseScenarioResponseDtoFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): BaseScenarioResponseDto {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        campaignId: !exists(json, 'campaign_id') ? undefined : json['campaign_id'],
        optimisationStrategy: !exists(json, 'optimisation_strategy')
            ? undefined
            : OptimisationStrategyFromJSON(json['optimisation_strategy']),
        scenarioName: !exists(json, 'scenario_name') ? undefined : json['scenario_name'],
        scenarioStatus: !exists(json, 'scenario_status')
            ? undefined
            : ScenarioStatusFromJSON(json['scenario_status']),
        countries: !exists(json, 'countries')
            ? undefined
            : json['countries'] === null
            ? null
            : (json['countries'] as Array<any>).map(CountryCodeIso2FromJSON),
        genders: !exists(json, 'genders')
            ? undefined
            : json['genders'] === null
            ? null
            : (json['genders'] as Array<any>).map(GenderFromJSON),
        ageGroups: !exists(json, 'age_groups')
            ? undefined
            : json['age_groups'] === null
            ? null
            : (json['age_groups'] as Array<any>).map(AgeGroupFromJSON),
        startDate: !exists(json, 'start_date')
            ? undefined
            : json['start_date'] === null
            ? null
            : new Date(json['start_date']),
        endDate: !exists(json, 'end_date')
            ? undefined
            : json['end_date'] === null
            ? null
            : new Date(json['end_date']),
        budgetConstraintType: !exists(json, 'budget_constraint_type')
            ? undefined
            : BudgetConstraintTypeFromJSON(json['budget_constraint_type']),
        adjustmentToleranceLevel: !exists(json, 'adjustment_tolerance_level')
            ? undefined
            : AdjustmentToleranceLevelFromJSON(json['adjustment_tolerance_level']),
        adFormats: !exists(json, 'ad_formats')
            ? undefined
            : json['ad_formats'] === null
            ? null
            : (json['ad_formats'] as Array<any>).map(ScenarioAdFormatResponseDtoFromJSON),
        minSpendPerChannels: !exists(json, 'min_spend_per_channels')
            ? undefined
            : json['min_spend_per_channels'] === null
            ? null
            : (json['min_spend_per_channels'] as Array<any>).map(
                  ScenarioMinSpendPerChannelResponseDtoFromJSON,
              ),
        isUsingGlobalCountry: !exists(json, 'is_using_global_country')
            ? undefined
            : json['is_using_global_country'],
        isAccessibleToEveryone: !exists(json, 'is_accessible_to_everyone')
            ? undefined
            : json['is_accessible_to_everyone'],
        id: !exists(json, 'id') ? undefined : json['id'],
        createdAt: !exists(json, 'created_at') ? undefined : new Date(json['created_at']),
        updatedAt: !exists(json, 'updated_at') ? undefined : new Date(json['updated_at']),
    };
}

export function BaseScenarioResponseDtoToJSON(value?: BaseScenarioResponseDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        campaign_id: value.campaignId,
        optimisation_strategy: OptimisationStrategyToJSON(value.optimisationStrategy),
        scenario_name: value.scenarioName,
        scenario_status: ScenarioStatusToJSON(value.scenarioStatus),
        countries:
            value.countries === undefined
                ? undefined
                : value.countries === null
                ? null
                : (value.countries as Array<any>).map(CountryCodeIso2ToJSON),
        genders:
            value.genders === undefined
                ? undefined
                : value.genders === null
                ? null
                : (value.genders as Array<any>).map(GenderToJSON),
        age_groups:
            value.ageGroups === undefined
                ? undefined
                : value.ageGroups === null
                ? null
                : (value.ageGroups as Array<any>).map(AgeGroupToJSON),
        start_date:
            value.startDate === undefined
                ? undefined
                : value.startDate === null
                ? null
                : value.startDate.toISOString(),
        end_date:
            value.endDate === undefined
                ? undefined
                : value.endDate === null
                ? null
                : value.endDate.toISOString(),
        budget_constraint_type: BudgetConstraintTypeToJSON(value.budgetConstraintType),
        adjustment_tolerance_level: AdjustmentToleranceLevelToJSON(value.adjustmentToleranceLevel),
        ad_formats:
            value.adFormats === undefined
                ? undefined
                : value.adFormats === null
                ? null
                : (value.adFormats as Array<any>).map(ScenarioAdFormatResponseDtoToJSON),
        min_spend_per_channels:
            value.minSpendPerChannels === undefined
                ? undefined
                : value.minSpendPerChannels === null
                ? null
                : (value.minSpendPerChannels as Array<any>).map(
                      ScenarioMinSpendPerChannelResponseDtoToJSON,
                  ),
        is_using_global_country: value.isUsingGlobalCountry,
        is_accessible_to_everyone: value.isAccessibleToEveryone,
        id: value.id,
        created_at: value.createdAt === undefined ? undefined : value.createdAt.toISOString(),
        updated_at: value.updatedAt === undefined ? undefined : value.updatedAt.toISOString(),
    };
}
